import { jsx as o } from "react/jsx-runtime";
import m, { createElement as h } from "react";
import { u } from "./index-6a632112.mjs";
import { s as n, d as x, a as s, e as g } from "./themes-5f0b3c3d.mjs";
import { f as $ } from "./fontWeights-a25f8f91.mjs";
import { l as p } from "./lineHeights-72d3110c.mjs";
const y = u.div`
  ol {
    margin-inline-start: ${n["2x"]} !important;
    margin-inline-end: 0px !important;
    padding-inline-start: 0px !important;
    padding-inline-end: 0px !important;

    list-style-position: inside;

    li span.ordered {
      padding-left: ${({ $size: e }) => e === "small" ? "10px" : e === "large" ? "18px" : "14px"} !important;
    }

    li ol,
    li ul {
      margin-top: ${n["1x"]};
      margin-inline-start: ${({ $size: e }) => e === "small" ? n["8x"] : e === "large" ? n["10x"] : n["9x"]} !important;
    }

    font-family: ${x.body};
    font-style: normal;
  }

  ul {
    margin-inline-start: ${({ $type: e }) => e === "none" ? "0px" : n["2x"]} !important;
    margin-inline-end: 0px !important;
    padding-inline-start: ${({ $size: e, $type: t }) => t === "none" ? "0" : e === "large" ? n["5x"] : n["4x"]} !important;
    padding-inline-end: 0px !important;
    font-family: ${x.body};
    font-style: normal;
  }

  li {
    position: relative;
    margin-bottom: ${n["1x"]};
  }

  li:last-of-type {
    margin-bottom: 0;
  }

  li ul {
    margin-inline-start: 0px !important;
    margin-inline-end: 0px !important;
  }
`, C = u.ul`
  list-style: none;
  font-size: ${({ size: e }) => e === "small" ? s.xsmall : e === "medium" ? s.small : s.medium};
  line-height: ${({ size: e }) => e === "small" ? p.small : e === "medium" ? p.medium : p.large};
  ${({ type: e, theme: t, size: r }) => {
  switch (e) {
    case "bullet":
      return `
          && > li:before {
            content: '•';
            position: absolute;
            left: -${r === "large" ? n["5x"] : n["4x"]};
            color: ${t.components.list.listBulletColor};
          }
        `;
    case "dash":
      return `
          && > li:before {
            content: '-';
            position: absolute;
            left: -${r === "large" ? n["5x"] : n["4x"]};
            color: ${t.components.list.listBulletColor};
          }
        `;
    case "square":
      return `
          && > li:before {
            content: '■';
            position: absolute;
            left: -${r === "large" ? n["5x"] : n["4x"]};
            color: ${t.components.list.listBulletColor};
          }
        `;
    default:
      return "";
  }
}}
`, b = u.ol`
  font-size: ${({ size: e }) => e === "small" ? s.xsmall : e === "medium" ? s.small : s.medium};
  line-height: ${({ size: e }) => e === "small" ? p.small : e === "medium" ? p.medium : p.large};
  list-style-type: ${({ type: e }) => e};
  color: ${(e) => e.theme.components.list.textColor};
  font-weight: ${(e) => e.size === "small" && g.regular.S.fontWeight || (e.size === "medium" || e.size === "large") && g.regular.L.fontWeight};
  ${({ type: e, $size: t }) => {
  if (e === "lower-roman" || e === "upper-roman")
    return `li span.ordered {
      padding-left: 0!important;
      position: absolute;
      left: ${t === "small" ? "10px" : t === "large" ? "18px" : "14px"} !important;`;
}}
}

  & ::marker {
    color: ${({ theme: e }) => e.components.list.orderedButllerColor};
    font-weight: ${({ $lowImpact: e }) => e ? $.body.medium : $.body.semibold};
  }
`, L = u.li`
  color: ${({ theme: e, $isLink: t }) => t ? e.components.list.listLinkColor : e.components.list.textColor};
  cursor: ${({ $isLink: e }) => e ? "pointer" : "default"};
  font-size: inherit;
  line-height: inherit;
  font-weight: ${(e) => e.size === "small" && g.regular.S.fontWeight || (e.size === "medium" || e.size === "large") && g.regular.L.fontWeight};
`, w = u.span`
  display: inline-flex;
  vertical-align: middle;
  margin-right: ${n["3x"]};
`, S = ({ component: e, color: t }) => /* @__PURE__ */ o(w, { role: "img", children: /* @__PURE__ */ o(e, { width: "20px", height: "20px", color: t }) }), d = ({ children: e, type: t, onClick: r }) => /* @__PURE__ */ o(
  L,
  {
    role: "listitem",
    size: t === "decimal" ? "medium" : "small",
    onClick: (a) => {
      r && r(a);
    },
    $isLink: !!r,
    children: [
      "decimal",
      "lower-alpha",
      "upper-alpha",
      "lower-roman",
      "upper-roman"
    ].includes(t) ? /* @__PURE__ */ o("span", { className: "ordered", children: e }) : e
  }
), O = ({
  size: e = "medium",
  type: t,
  children: r,
  lowImpact: a = !1
}) => {
  const l = [
    "decimal",
    "lower-alpha",
    "upper-alpha",
    "lower-roman",
    "upper-roman"
  ].includes(t) ? f : k;
  return /* @__PURE__ */ o(y, { $size: e, $type: t, children: /* @__PURE__ */ o(l, { role: "list", size: e, type: t, lowImpact: a, children: m.Children.map(r, (i, c) => i && typeof i == "string" ? /* @__PURE__ */ o(d, { size: e, type: t, children: i }, c) : i && m.isValidElement(i) && i.type === d ? m.cloneElement(i, {
    key: c,
    size: e,
    onClick: i.props.onClick
  }) : null) }) });
}, k = ({
  type: e,
  size: t = "medium",
  children: r
}) => /* @__PURE__ */ o(C, { role: "list", type: e, size: t, children: m.Children.map(r, (a, l) => a && m.isValidElement(a) && a.type === d ? /* @__PURE__ */ h(d, { ...a.props, size: t, key: l, type: e }, a.props.children) : null) }), f = ({
  size: e = "medium",
  children: t,
  type: r = "decimal",
  lowImpact: a
}) => /* @__PURE__ */ o(
  b,
  {
    role: "list",
    size: e,
    type: r,
    $lowImpact: a,
    children: m.Children.map(t, (l, i) => m.isValidElement(l) && l.type === d ? /* @__PURE__ */ o(d, { type: r, ...l.props, children: m.Children.toArray(l.props.children) }, i) : m.isValidElement(l) && l.type === f ? /* @__PURE__ */ o(f, { size: e, type: l.props.type, children: l.props.children }, i) : /* @__PURE__ */ o("li", { children: l }, i))
  }
);
export {
  O as List,
  S as ListIcon,
  d as ListItem
};
